export function resolveManageActivityProbeResults(
  results: ReadonlyArray<PromiseSettledResult<boolean>>,
): boolean {
  if (results.some((result) => result.status === 'fulfilled' && result.value)) {
    return true
  }

  if (results.some((result) => result.status === 'rejected')) {
    throw new Error('Unable to determine whether manage activity exists')
  }

  return false
}
